import { render } from "./Commissions.vue?vue&type=template&id=31756935&scoped=true"
import script from "./Commissions.vue?vue&type=script&lang=js"
export * from "./Commissions.vue?vue&type=script&lang=js"

import "./Commissions.vue?vue&type=style&index=0&id=31756935&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31756935"]])

export default __exports__